import React from 'react'
import { useSelector } from 'react-redux'
import { Card } from 'reactstrap'
import Loader from 'views/pages/Loader'
import { useWhereYouLeftCourse } from '../../Admin/useWhereYouLeftCourse'
import '../style.css'
function WhereYouLeftCourse() {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  // Fetching where you left course
  useWhereYouLeftCourse()

  const {
    whereYouLeftData: {
      width,
      whereYouLeftUrl,
      lastActivity,
      loadingActivity,
      loadingProgress,
    },
  } = useSelector((state) => state.dashboard)

  return (
    <Card className='p-2'>
      {loadingActivity || loadingProgress ? (
        <div className='text-center'>
          <Loader color='default' />
        </div>
      ) : (
        <div className='achievement-tile-content content-box'>
          <div className='achievement-wrapper text-center'>
            <span className='achievement-label pb-2'>
              {language.general ? language.general.where_you_left : null}:
            </span>
          </div>
          <div className='achievement-bar-wrapper'>
            <div
              className='achievement-bar-progress'
              style={width ? { width: `${width}%` } : { width: `0%` }}
            ></div>
          </div>
          <div className='achievement-wrapper text-center pt-2'>
            <div className='progress-bar-completion'>
              <p className='pb-0'>
                {(whereYouLeftUrl && (
                  <a href={`${whereYouLeftUrl}`}>
                    {lastActivity && lastActivity.title}
                  </a>
                )) || <a href>{lastActivity && lastActivity.title}</a>}

                {/* {courseStatus === null ? ( */}
                {/* <span role='button'>
                {courseStatus && courseStatus >= '3' ? (
                  <p>
                    Completed (<a href>{lastActivity && lastActivity.title}</a>)
                  </p>
                ) : (
                  <a href className='pb-0'>
                    {lastActivity && lastActivity.title}
                  </a>
                )}
              </span> */}
                {/* ) : (
                <p> No Course Available </p>
              )} */}
              </p>
            </div>
          </div>
        </div>
      )}
    </Card>
  )
}

export default React.memo(WhereYouLeftCourse)
